var objectFitImages = require('object-fit-images');

document.addEventListener("DOMContentLoaded", function() {

	// let object_fit = document.querySelectorAll(".object-contain, .object-cover, .object-fill");

	// if(object_fit && object_fit.length > 0) {
	// 	for(let i = 0; i < object_fit.length; i++) {
	// 		object_fit[i].classList.add('object-fit-polyfill');
	// 	}
	// }

	// objectFitImages();
});